import { Component, OnInit } from '@angular/core';
import { AdminAccountComponent } from '../account.component';
import { PAGE_ACTION, DEFAULT_PASSWORD, SwalResponseHandler } from '../../../../shared/constants';

declare const swal: any;

@Component({
  selector: 'app-account-edit',
  templateUrl: './account-edit.component.html',
  styleUrls: ['./account-edit.component.scss']
})
export class AdminAccountEditComponent extends AdminAccountComponent implements OnInit {
  public title = 'Account Edit';
  public page = PAGE_ACTION.EDIT;
  public token = '';
  public loader = false;

  public ngOnInit() {
    super.ngOnInit();
    this.filters.include = ['accessTokens'];
    this.loadItem();
    this.createForm();
  }

  public createForm() {
    super.createForm();
    this.form.removeControl('password');
  }

  public bindData(data: any) {
    super.bindData(data);
    if (data && data.accessTokens && data.accessTokens.length) {
      this.token = data.accessTokens[0].id;
    }
  }

  public generate(email) {
    this.loader = true;
    var credentials = {
      email: email,
      password: DEFAULT_PASSWORD
    };
    this.apiService.login(credentials, 'user')
    .takeUntil(this.ngUnsubscribe)
    .subscribe((res: any) => {
      this.loader = false;
      swal(SwalResponseHandler.message('Access Token', 'Congratulation new token was generated'));
      this.token = res.data.id;
    });
  }

  public sendmail(email) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Send'
    }).then((result) => {
      if (result.value) {
        this.loader = true;
        this.apiService.sendToken(email)
        .takeUntil(this.ngUnsubscribe)
        .subscribe((res: any) => {
          this.loader = false;
          swal(SwalResponseHandler.message('Access Token', 'Token information was sent'));
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/account/edit/account-edit.component.ts